import config from '../../config/config';

/**
 * POST /email-api/Contact — internal ops notification.
 * MessageType is required; subject is inferred server-side.
 */

export async function sendOpsNotification(params) {
  const {
    messageType,
    contactForm,
    subscriptionCancellation,
    joinBusiness,
    plain,
  } = params;

  if (!messageType) {
    throw new Error('messageType is required');
  }

  const body = { MessageType: messageType };

  if (contactForm) {
    body.ContactForm = {
      FirstName: contactForm.firstName,
      LastName: contactForm.lastName,
      Email: contactForm.email,
      Message: contactForm.message,
    };
  }

  if (subscriptionCancellation) {
    body.SubscriptionCancellation = {
      BusinessId: String(subscriptionCancellation.businessId),
      RequesterEmail: subscriptionCancellation.requesterEmail,
    };
  }

  if (joinBusiness) {
    body.JoinBusiness = {
      Email: joinBusiness.email,
      BusinessId: String(joinBusiness.businessId),
    };
  }

  if (plain) {
    body.Plain = {
      Subject: plain.subject,
      Message: plain.message,
    };
  }

  const response = await fetch(`${config.apimUrl}/email-api/Contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': config.apimKeyEmailService,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.status;
}

export const messagingService = {
  sendOpsNotification,

  /** Website Contact Us form */
  async submitContactForm({ firstName, lastName, email, message }) {
    return sendOpsNotification({
      messageType: 'contact_form',
      contactForm: {
        firstName,
        lastName,
        email,
        message,
      },
    });
  },

  /**
   * Join / link to existing business — only email + businessId; server loads names.
   */
  async submitJoinBusinessRequest({ email, businessId }) {
    return sendOpsNotification({
      messageType: 'join_business',
      joinBusiness: {
        email,
        businessId,
      },
    });
  },

  /**
   * Provider subscription cancellation — only businessId + requester email; server loads details.
   */
  async requestEndSubscription({ businessId, requesterEmail }) {
    if (!businessId || !requesterEmail) {
      throw new Error('businessId and requesterEmail are required');
    }
    return sendOpsNotification({
      messageType: 'subscription_cancellation',
      subscriptionCancellation: {
        businessId,
        requesterEmail: String(requesterEmail).trim(),
      },
    });
  },
};
